import(/* webpackMode: "eager" */ "/home/runner/work/dogs-blog/dogs-blog/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["useImageUpload"] */ "/home/runner/work/dogs-blog/dogs-blog/src/shared/lib/image-upload/useImageUpload.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dogs-blog/dogs-blog/src/shared/ui/buttons/BackButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dogs-blog/dogs-blog/src/shared/ui/buttons/ShareButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dogs-blog/dogs-blog/src/shared/ui/call-to-number/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dogs-blog/dogs-blog/src/shared/ui/HiddenLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dogs-blog/dogs-blog/src/shared/ui/Logo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dogs-blog/dogs-blog/src/shared/ui/ScrollToTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dogs-blog/dogs-blog/src/shared/ui/theme/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dogs-blog/dogs-blog/src/shared/ui/upload-images/BasicDropzone.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Clinics","ClinicsContext"] */ "/home/runner/work/dogs-blog/dogs-blog/src/widgets/clinics/ui/Clinics.tsx");
